import request from '@axios'

export function getCompany(id) {
  return request({
    url: '/company',
    method: 'get',
    params: {id}
  })
}

export function deleteCompany(id) {
  return request({
    url: '/company',
    method: 'delete',
    params: {id}
  })
}

export function createCompany(data) {
  return request({
    url: '/company',
    method: 'post',
    data: data
  })
}

export function saveCompanyByStep(step, data) {
  return request({
    url: `/company/save/${step}`,
    method: 'post',
    data: data
  })
}

export function getCompanyInfo(id) {
  return request({
    url: `/company/info`,
    method: 'get',
    params: {id}
  })
}

export function getQBCompanyInfo(id) {
  return request({
    url: `/company/qb_info`,
    method: 'get',
    params: {id}
  })
}

export function getCompanyTrafficAllAnalytics(data) {
  return request({
    url: `/company/analytics/traffic/all`,
    method: 'post',
    data: data
  })
}

export function getCompanyTrafficMoneyAnalytics(data) {
  return request({
    url: `/company/analytics/traffic/money`,
    method: 'post',
    data: data
  })
}

export function getCompanyAhrefsDR(data) {
  return request({
    url: `/company/analytics/ahrefs/dr`,
    method: 'post',
    data: data
  })
}

export function getCompanyAhrefsKeywords(data) {
  return request({
    url: `/company/analytics/ahrefs/keywords`,
    method: 'post',
    data: data
  })
}

export function getCompanyAhrefsTraffic(data) {
  return request({
    url: `/company/analytics/ahrefs/traffic`,
    method: 'post',
    data: data
  })
}

export function getCompanyAhrefsDonors(data) {
  return request({
    url: `/company/analytics/ahrefs/donors`,
    method: 'post',
    data: data
  })
}

export function getCompanyTotalAnalytics(id) {
  return request({
    url: `/company/analytics/total`,
    method: 'post',
    data: {id}
  })
}
export function getCompanyLinkBuildingAnalytics(id) {
  return request({
    url: `/company/analytics/link_building`,
    method: 'post',
    data: {id}
  })
}
export function getCompanyBrandKeywordsAnalytics(id) {
  return request({
    url: `/company/analytics/brand/keywords`,
    method: 'post',
    data: {id}
  })
}

export function getCompanyTrafficHealthAnalytics(data) {
  return request({
    url: `/company/analytics/traffic/health`,
    method: 'post',
    data: data
  })
}

export function getCompanySearchConsoleAnalytics(data) {
  return request({
    url: `/company/analytics/searchConsole`,
    method: 'post',
    data: data
  })
}

export function getCompanySummary(id) {
  return request({
    url: `/company/company-summary`,
    method: 'get',
    params: {id}
  })
}

export function getSites(id) {
  return request({
    url: `/company/sites`,
    method: 'get',
    params: {id}
  })
}

export function updateOAuthData(data) {
  return request({
    url: `/company/oauth`,
    method: 'put',
    data: data
  })
}

export function updatePermissions(data) {
  return request({
    url: `/company/permissions`,
    method: 'put',
    data: data
  })
}

export function updateBrandKeywords(data) {
  return request({
    url: `/company/brand/keywords`,
    method: 'put',
    data: data
  })
}
